import { render } from "./ConfirmationScreen.vue?vue&type=template&id=c1b10638&scoped=true"
import script from "./ConfirmationScreen.vue?vue&type=script&lang=js"
export * from "./ConfirmationScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=c1b10638&lang=scss&scoped=true"
import "./ConfirmationScreen.vue?vue&type=style&index=1&id=c1b10638&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.8\\installer\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1b10638"]])

export default __exports__